module.exports = __webpack_public_path__ + "static/media/FT-FONDO-MAPPING.d1ceadb4.jpg";